import Intercom from '@intercom/messenger-js-sdk';
import { useVariable } from '@softwareimaging/backstage';
import { FC, PropsWithChildren, useEffect, useRef } from 'react';
import { Outlet } from 'react-router';
import { useIntercomHash } from '../api/hooks/intercom';
import { useUser } from '../authentication/hooks/user';
import { Variables } from '../backstage/config';

export const IntercomProvider: FC<PropsWithChildren> = ({ children }) => {
  const user = useUser();
  const intercomAppId = useVariable<Variables>('intercomAppId');
  const initRef = useRef<boolean>(false);

  const [hash] = useIntercomHash();

  useEffect(() => {
    if (initRef.current || !intercomAppId) return;
    Intercom({
      app_id: intercomAppId,
      user_id: user.id,
      user_hash: hash.hash,
      name: `${user.firstName} ${user.lastName}`,
      email: user.email,
      // prettier-ignore
      "daas_role": user.role.type
    });
    initRef.current = true;
  }, [user, intercomAppId]);

  return <Outlet />;
};
